{
  "users": {
    "title": "المستخدمون والصلاحيات",
    "subtitle": "للمالك الرئيسي فقط · حسابات المنسقين تُدار من صفحة كل منسق",
    "addOwner": "إضافة مالك",
    "owners": "الملاك",
    "disabled": "موقوف",
    "superOwnerSummary": "المالك الرئيسي · كل الصلاحيات",
    "ownerSummary": "مالك مضاف · {{n}} صلاحية",
    "invitePending": "دعوة معلّقة",
    "empty": "لا يوجد ملاك مضافون"
  },
  "permissions": {
    "heading": "صلاحيات {{name}}",
    "saved": "تم حفظ الصلاحيات — تُطبق من الطلب التالي للمستخدم",
    "statusUpdated": "تم تحديث حالة الحساب",
    "inviteResent": "تم إرسال دعوة جديدة",
    "resendInvite": "إعادة إرسال الدعوة",
    "disable": "إيقاف الحساب",
    "enable": "تفعيل الحساب",
    "save": "حفظ التغييرات",
    "superOwnerNote": "المالك الرئيسي يملك كل الصلاحيات، بما فيها إدارة المستخدمين والإعدادات، ولا يمكن تعديلها.",
    "changeEmail": "تغيير البريد"
  },
  "invite": {
    "title": "إضافة مالك",
    "description": "تصله دعوة بالبريد لتعيين كلمة المرور. الصلاحيات تبدأ فارغة.",
    "firstName": "الاسم الأول",
    "lastName": "اسم العائلة",
    "email": "البريد الإلكتروني",
    "phone": "الجوال",
    "required": "مطلوب",
    "submit": "إرسال الدعوة",
    "sent": "تم إرسال الدعوة (الرابط صالح 48 ساعة)",
    "failed": "تعذر الإرسال"
  }
}
